export const EMAIL_REGEX = new RegExp(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);

export const validate = (values, validations) => {
  const errors = {};
  if (validations.required) {
    validations.required.fields.forEach(field => {
      if (
        typeof values[field] === 'undefined' ||
        (typeof values[field] === 'string' && !values[field].trim())
      ) {
        errors[field] = 'Required';
      }
    });
  }

  if (validations.charCount) {
    validations.charCount.fields.forEach(field => {
      if (values[field]) {
        if (
          validations.charCount.min &&
          values[field].length < validations.charCount.min
        ) {
          errors[field] = `Must be at least ${
            validations.charCount.min
          } characters`;
        }

        if (
          validations.charCount.max &&
          values[field].length > validations.charCount.max
        ) {
          errors[field] = `Must be less than ${validations.charCount.max +
            1} characters`;
        }
      }
    });
  }

  if (validations.numCount) {
    validations.numCount.fields.forEach(field => {
      if (values[field]) {
        if (
          !isNaN(validations.numCount.min) &&
          +values[field] < validations.numCount.min
        ) {
          errors[field] = `Must be at least ${validations.numCount.min}`;
        }
        if (
          !isNaN(validations.numCount.max) &&
          +values[field] > validations.numCount.max
        ) {
          errors[field] = `Must be less than ${validations.numCount.max + 1}`;
        }
      }
    });
  }

  if (validations.noNegative) {
    validations.noNegative.fields.forEach(field => {
      if (values[field] && values[field] < 0) {
        errors[field] = `Cannot be negative`;
      }
    });
  }

  if (validations.match) {
    validations.match.fields.forEach(field => {
      if (
        values[field] &&
        values[field] !== values[validations.match.toMatch]
      ) {
        errors[field] = 'Passwords do not match';
      }
    });
  }

  if (validations.isNumber) {
    validations.isNumber.fields.forEach(field => {
      if (values[field] && isNaN(values[field])) {
        errors[field] = 'Must be a number';
      }
    });
  }

  if (validations.email) {
    validations.email.fields.forEach(field => {
      if (values[field] && !EMAIL_REGEX.test(values[field])) {
        errors[field] = 'Invalid email';
      }
    });
  }

  return errors;
};



// WEBPACK FOOTER //
// ./src/reducers/form/validate.js